<Panel 
  show={full}
  align="right" 
  mb="nm"
  overflow="hidden"
  h="3"
  flex>
  <Heading xl thin dark>Nuevo reporte</Heading>
  <IconButton
    on:click={() => open = false}
    name="close"
    size=2 w="2.5" h="2.5"
    pointer hover
    color="primary"
    round
    />
</Panel>

<Panel>
  <TextField 
    bind:value={rpt.title} 
    label="Titulo"
    hints="Ingresa un título para este reporte"
    maxlen="80" size="38" required
    messages={{
      errors: {
        'is_empty': 'Debes ingresar un título',
        'max_length_exceeded': 'El título es demasiado largo !'
      },
      valid: 'Título correcto'
    }}
    />

  <NotesField 
    bind:value={rpt.descr} 
    label="Descripción"
    hints="Ingresa una descripción breve de qué hace este reporte"
    maxlen="120" layout="stacked"
    messages={{
      errors: {
        'max_length_exceeded': 'El título es demasiado largo !'
      },
      valid: 'Correcto'
    }}
    />

  <SelectField
    bind:value={rpt.state}
    options={[
      {value: 'E', text: 'En Edición'},
      {value: 'A', text: 'Activo'},
      {value: 'I', text: 'Inactivo'},
    ]}
    label="Estado"
    required
    />

  <SelectField
    bind:value={rpt.builder}
    options={[
      {value: '', text: 'elegir ...'},
      {value: 'xls-builder', text: 'XLS'}
    ]}
    label="Tipo del reporte"
    hints="Indique que generador se usara para este reporte (XLS, ...)"
    required
    />
</Panel>

<Panel show={full} mt="md" align="right">
  <Button 
    on:click={createIt}
    color="primary" 
    nm bold 
    border="0" rounded="xs"
    py="nm" px="nm" 
    bg="transparent"
    pointer hover
    line="fit"
    >
    AGREGAR ESTE REPORTE
    &nbsp;
    <Icon name="valid" md mb="-2px" line="fit"/>
  </Button> 
</Panel>

<script>
  import { onMount, tick, createEventDispatcher } from 'svelte'
  import { Panel, Button, Heading, Box, Icon, Label } from 'svelte-stylo'
  import { TextField, NotesField, SelectField, IconButton } from 'svelte-stylo-kit'
  import API from '@/api'
  import { cloned, randid } from '@/helpers'
  import { ReportDef } from '@/models'
  import XlsBuilderForm from './XlsBuilderForm.svelte'

  export let 
    rpt,
    open = true,    
    full = false;

  let 
    emit = createEventDispatcher();

  async function createIt() {
    try {
      rpt.definition = ReportDef.emptyDefinition(rpt.builder);
      let rsp = await API.reportDefs.post(rpt);

      // must force "two" hash changes to reload it
      // because changing the id= does not remount it
      // window.history.back();
      // setTimeout(() => {
        // }, 100)
      window.location = "#reporte?id="+rsp.id; 
      open = false;
    }
    catch (err) {
      alert("problema al crear")
      console.log("ReportDefEditor create err=", err)
    }
  }

</script>
